/* Velour — plná stránka košíka (/cart).
   Nevlastní dáta ani ich nenačítava: prihlási sa cez VELOUR.onCartChange
   a vykreslí, čo príde. Košík ťahá a mení výhradne velour-cart.js, takže
   drawer a táto stránka nikdy neukazujú dva rôzne stavy. */
(function () {
  var items = document.getElementById('cartPageItems');
  if (!items) return;

  var deliveryBlock = document.getElementById('cartPageDelivery');
  var summaryBlock = document.getElementById('cartPageSummary');
  var totalEl = document.getElementById('cartPageTotal');
  var checkoutBtn = document.getElementById('cartPageCheckout');
  var shipLabel = document.getElementById('cartPageShippingLabel');
  var shipFill = document.getElementById('cartPageShippingFill');

  function money(cents) {
    return window.VELOUR.money ? window.VELOUR.money(cents) : (cents / 100).toFixed(2) + ' €';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* Obrázky z Ajax Cart API prídu v ľubovoľnej veľkosti. Na stránke sú
     výrazne väčšie než v draweri, tak si vypýtame konkrétnu šírku —
     inak by sa sťahoval originál a na mobile by to bolo cítiť. */
  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /* Vlastnosti položky s podčiarkovníkom sú interné (appky si do nich
     odkladajú stav) — zákazníkovi sa nikdy nezobrazujú. */
  function visibleProps(props) {
    if (!props) return [];
    return Object.keys(props).filter(function (k) {
      return k.charAt(0) !== '_' && props[k];
    }).map(function (k) { return { name: k, value: props[k] }; });
  }

  function lineHtml(item, isDiscountActive) {
    var props = visibleProps(item.properties).map(function (p) {
      return '<div class="cart-line-prop"><span>' + esc(p.name) + ':</span> ' + esc(p.value) + '</div>';
    }).join('');

    var desc = item.product_description
      ? '<p class="cart-line-desc">' + esc(item.product_description.replace(/<[^>]*>/g, '').trim()) + '</p>'
      : '';

    var img = item.image
      ? '<img src="' + esc(sized(item.image, 400)) + '" alt="' + esc(item.product_title) + '" loading="lazy" width="200" height="200">'
      : '';

    var vt = (item.variant_title || '').trim().toLowerCase();
    var is1ml = vt === '1ml' || vt === '1 ml';
    var isSet = item.product_type === 'Set';
    var itemQualifies = isDiscountActive && !is1ml && !isSet;

    var was = '';
    var finalPrice = item.final_line_price;

    if (item.original_line_price > item.final_line_price) {
      was = '<span class="cart-line-was">' + money(item.original_line_price) + '</span>';
      finalPrice = item.final_line_price;
    } else if (itemQualifies) {
      var discounted = Math.round(item.final_line_price * 0.90);
      was = '<span class="cart-line-was">' + money(item.final_line_price) + '</span>';
      finalPrice = discounted;
    }

    return '' +
      '<div class="cart-line" data-key="' + esc(item.key) + '">' +
        '<a class="cart-line-visual" href="' + esc(item.url) + '">' + img + '</a>' +
        '<div class="cart-line-info">' +
          '<div class="cart-line-brand">' + esc(item.vendor) + '</div>' +
          '<a class="cart-line-name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<div class="cart-line-variant">' + esc(item.variant_title) + '</div>' : '') +
          window.VELOUR.vialNote(item.variant_title) +
          props +
          desc +
          '<button class="cart-line-remove" data-key="' + esc(item.key) + '" type="button">Odstrániť</button>' +
        '</div>' +
        '<div class="cart-line-side">' +
          '<div class="cart-line-price">' + was + money(finalPrice) + '</div>' +
          '<div class="cart-line-qty">' +
            '<button class="cart-line-qty-btn" data-key="' + esc(item.key) + '" data-delta="-1" type="button" aria-label="Ubrať">&#8722;</button>' +
            '<span class="cart-line-qty-num">' + item.quantity + '</span>' +
            '<button class="cart-line-qty-btn" data-key="' + esc(item.key) + '" data-delta="1" type="button" aria-label="Pridať">&#43;</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  // Dodávka namiesto fajky, keď je doprava zadarmo. Inline SVG, aby to bola
  // jedna požiadavka menej a aby sa dala zafarbiť cez currentColor.
  var VAN_ICON = '<svg class="cart-van" viewBox="0 0 24 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 2h12v9H1z"/><path d="M13 5h4l3 3v3h-7z"/><circle cx="6" cy="12.5" r="1.8"/><circle cx="16.5" cy="12.5" r="1.8"/></svg>';


  function renderShipping(totalCents) {
    if (!shipLabel || !shipFill) return;
    var freeFrom = window.VELOUR.freeShippingFromCents || 5000;
    var missing = freeFrom - totalCents;
    if (missing > 0) {
      shipLabel.innerHTML = 'Ešte <strong>' + money(missing) + '</strong> a doprava na výdajné miesto je zadarmo';
      shipFill.style.width = Math.min(100, (totalCents / freeFrom) * 100) + '%';
      shipFill.classList.remove('full');
      shipLabel.classList.remove('is-free');
    } else {
      shipLabel.innerHTML = VAN_ICON + 'Doprava na výdajné miesto zadarmo';
      shipLabel.classList.add('is-free');
      shipFill.style.width = '100%';
      shipFill.classList.add('full');
    }
  }

  /* ---------- konečná suma podľa krajiny ----------
     Sadzby sú v nastaveniach témy ako text ("3,49 €"), tak ich tu prečítame
     na centy. Doprava zdarma platí len na výdajné miesto (data-free). */
  var countryBox = document.getElementById('cartShipCountry');
  var calcTable = document.getElementById('cartShipCalc');
  var staticTable = document.getElementById('cartShipStatic');
  var COUNTRY_KEY = 'velour.shipCountry';
  var country = 'SK';

  function toCents(text) {
    var n = parseFloat(String(text || '').replace(',', '.').replace(/[^\d.]/g, ''));
    return isNaN(n) ? null : Math.round(n * 100);
  }

  if (countryBox && calcTable) {
    country = countryBox.getAttribute('data-default') || 'SK';
    try {
      var saved = localStorage.getItem(COUNTRY_KEY);
      if (saved === 'SK' || saved === 'CZ') {
        country = saved;
      } else if (navigator.language && navigator.language.toLowerCase().indexOf('cs') === 0) {
        country = 'CZ';
      }
    } catch (e) {}

    countryBox.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-country]');
      if (!btn) return;
      country = btn.getAttribute('data-country');
      try { localStorage.setItem(COUNTRY_KEY, country); } catch (err) {}
      if (window.VELOUR._lastCart) {
        var dInfo = window.VELOUR.calculateCartDiscount ? window.VELOUR.calculateCartDiscount(window.VELOUR._lastCart) : null;
        var effTot = dInfo ? dInfo.effectiveTotal : window.VELOUR._lastCart.total_price;
        renderShipCalc(effTot, dInfo);
      }
    });

    countryBox.hidden = false;
    calcTable.hidden = false;
    if (staticTable) staticTable.hidden = true;
  }

  var subRows = document.getElementById('cartPageSubRows');
  var subtotalEl = document.getElementById('cartPageSubtotal');
  var discountRow = document.getElementById('cartPageDiscountRow');
  var discountAmountEl = document.getElementById('cartPageDiscount');
  var shipRowLabel = document.getElementById('cartPageShipLabel');
  var shipRowAmount = document.getElementById('cartPageShipAmount');
  var totalLabel = document.getElementById('cartPageTotalLabel');
  var czkRow = document.getElementById('cartPageCzkRow');
  var czkAmountEl = document.getElementById('cartPageCzkAmount');
  var czkNotice = document.getElementById('cartCzkNotice');
  var COUNTRY_NAME = { SK: 'Slovensko', CZ: 'Česko' };
  var METHOD_NAME = { pickup: 'výdajné miesto', home: 'kuriér na adresu' };

  /* Globe drží voľbu v rádiách (value home / pickup). Kým nie je nič
     vybraté, vraciame null a súhrn počíta s výdajným miestom ako "od". */
  function selectedMethod() {
    var r = deliveryBlock && deliveryBlock.querySelector('input[name^="globe-delivery-method"]:checked');
    return r && METHOD_NAME[r.value] ? r.value : null;
  }

  function feeFor(method, subtotalCents) {
    var row = calcTable.querySelector('[data-ship-row="' + method + '"]');
    if (!row) return null;
    var fee = toCents(row.getAttribute(country === 'CZ' ? 'data-cz' : 'data-sk'));
    if (fee === null) return null;
    var freeFrom = window.VELOUR.freeShippingFromCents || 5000;
    return row.hasAttribute('data-free') && subtotalCents >= freeFrom ? 0 : fee;
  }

  var lastMethod;

  function renderShipCalc(totalCents, discountInfo) {
    if (!countryBox || !calcTable) return;
    if (!discountInfo && window.VELOUR._lastCart && window.VELOUR.calculateCartDiscount) {
      discountInfo = window.VELOUR.calculateCartDiscount(window.VELOUR._lastCart);
    }
    discountInfo = discountInfo || { discountCents: 0, effectiveTotal: totalCents, isDiscounted: false };
    totalCents = discountInfo.effectiveTotal;

    var freeFrom = window.VELOUR.freeShippingFromCents || 5000;
    var method = selectedMethod();
    lastMethod = method;

    countryBox.querySelectorAll('[data-country]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-country') === country ? 'true' : 'false');
    });

    /* Cenník: sadzby pre zvolenú krajinu, zvýraznený zvolený spôsob. */
    calcTable.querySelectorAll('[data-ship-row]').forEach(function (row) {
      var kind = row.getAttribute('data-ship-row');
      var fee = feeFor(kind, totalCents);
      var feeEl = row.querySelector('[data-ship-fee]');
      var noteEl = row.querySelector('[data-ship-free-note]');
      row.classList.toggle('is-selected', kind === method);

      if (fee === null) {
        feeEl.textContent = row.getAttribute(country === 'CZ' ? 'data-cz' : 'data-sk');
        return;
      }
      feeEl.innerHTML = fee === 0 ? '<span class="cart-ship-free-tag">ZADARMO</span>' : money(fee);
      if (noteEl) {
        noteEl.innerHTML = fee === 0 ? '' : '<strong>ZADARMO</strong> od ' + money(freeFrom);
        noteEl.style.display = fee === 0 ? 'none' : '';
      }
    });

    /* Súhrn: Pôvodná cena + Zľava + Doprava = Spolu. */
    var shipFee = feeFor(method || 'pickup', totalCents);
    var grandTotalCents = totalCents;
    if (!subRows || shipFee === null) {
      if (subRows) subRows.hidden = true;
      if (totalLabel) totalLabel.textContent = 'Medzisúčet';
      if (totalEl) totalEl.textContent = money(totalCents);
      grandTotalCents = totalCents;
    } else {
      subRows.hidden = false;
      var rawCart = window.VELOUR._lastCart;
      var originalSubtotal = rawCart ? rawCart.total_price : totalCents;

      if (discountInfo.isDiscounted && discountInfo.discountCents > 0) {
        subtotalEl.textContent = money(originalSubtotal);
        if (discountRow) {
          discountRow.hidden = false;
          if (discountAmountEl) discountAmountEl.textContent = '−' + money(discountInfo.discountCents);
        }
      } else {
        subtotalEl.textContent = money(totalCents);
        if (discountRow) discountRow.hidden = true;
      }

      shipRowLabel.textContent = 'Doprava · ' + COUNTRY_NAME[country] + ', ' + METHOD_NAME[method || 'pickup'];
      shipRowAmount.innerHTML = shipFee === 0 ? '<span class="cart-ship-free-tag">ZADARMO</span>' : money(shipFee);
      totalLabel.textContent = method ? 'Spolu' : 'Spolu od';
      totalEl.textContent = money(totalCents + shipFee);
      grandTotalCents = totalCents + shipFee;
    }

    if (country === 'CZ') {
      var czkRate = 25.2;
      var czkEst = Math.round((grandTotalCents / 100) * czkRate);
      if (czkRow && czkAmountEl) {
        czkRow.hidden = false;
        czkAmountEl.textContent = 'cca ' + czkEst.toLocaleString('cs-CZ') + ' Kč';
      }
      if (czkNotice) {
        czkNotice.hidden = false;
      }
    } else {
      if (czkRow) czkRow.hidden = true;
      if (czkNotice) czkNotice.hidden = true;
    }
  }

  /* Globe nevysiela udalosť pri zmene spôsobu a svoju uloženú voľbu
     obnovuje sám po načítaní, takže sledujeme jeho časť DOMu. Prekreslíme
     len pri skutočnej zmene — inak by vlastné úpravy cenníka (je v tom
     istom bloku) spúšťali observer donekonečna. */
  if (deliveryBlock && calcTable) {
    var pending = false;
    var recheck = function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        if (selectedMethod() !== lastMethod && window.VELOUR._lastCart) {
          var dInfo = window.VELOUR.calculateCartDiscount ? window.VELOUR.calculateCartDiscount(window.VELOUR._lastCart) : null;
          var effTot = dInfo ? dInfo.effectiveTotal : window.VELOUR._lastCart.total_price;
          renderShipCalc(effTot, dInfo);
        }
      }, 30);
    };
    deliveryBlock.addEventListener('change', recheck);
    /* Globe prepína rádio programovo (bez udalosti change) a niekedy až
       po chvíli, tak sa po kliknutí pozrieme ešte niekoľkokrát. */
    deliveryBlock.addEventListener('click', function () {
      [50, 300, 1000].forEach(function (ms) { setTimeout(recheck, ms); });
    });
    new MutationObserver(recheck).observe(deliveryBlock, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'class', 'checked'] });
  }

  function render(cart) {
    var count = cart.item_count || 0;

    if (count === 0) {
      items.innerHTML =
        '<div class="cart-page-empty">' +
          '<div class="cart-page-empty-title">Váš košík je prázdny</div>' +
          '<div class="cart-page-empty-sub">Pridajte vôňu pre začiatok</div>' +
          '<a class="cart-page-empty-btn" href="' + esc((window.VELOUR.routes && window.VELOUR.routes.all_products_collection_url) || '/collections/all') + '">Prezrieť katalóg</a>' +
        '</div>';
      if (deliveryBlock) deliveryBlock.hidden = true;
      if (summaryBlock) summaryBlock.hidden = true;
      if (upsellBlock) upsellBlock.hidden = true;
      if (incompleteBanner) incompleteBanner.hidden = true;
      return;
    }

    var discountInfo = window.VELOUR.calculateCartDiscount ? window.VELOUR.calculateCartDiscount(cart) : { discountCents: 0, effectiveTotal: cart.total_price, isDiscounted: false };
    var effectiveTotal = discountInfo.effectiveTotal;

    items.innerHTML = cart.items.map(function (it) {
      return lineHtml(it, discountInfo.isDiscounted);
    }).join('');

    if (deliveryBlock) deliveryBlock.hidden = false;
    if (summaryBlock) summaryBlock.hidden = false;
    if (totalEl) totalEl.textContent = money(effectiveTotal);
    if (checkoutBtn) checkoutBtn.classList.remove('disabled');
    renderShipping(effectiveTotal);
    renderShipCalc(effectiveTotal, discountInfo);
    updateUpsell(effectiveTotal, cart);
    updateIncompleteBanner(cart, discountInfo);
  }

  /* ---------- Upozornenie na nekompletný set (3 alebo 4 z 5 vôní) ---------- */
  var incompleteBanner = document.getElementById('cartIncompleteBanner');
  var incompleteTitle = document.getElementById('cartIncompleteTitle');
  var incompleteSub = document.getElementById('cartIncompleteSub');
  var incompleteLink = document.getElementById('cartIncompleteLink');
  var incompleteCards = incompleteBanner ? Array.from(incompleteBanner.querySelectorAll('.cart-incomplete-card')) : [];
  var currentIncompleteSize = '2ml';

  function updateIncompleteBanner(cart, discountInfo) {
    if (!incompleteBanner) return;
    var count = discountInfo ? discountInfo.qualifyingCount : 0;
    var totalItemsCount = (cart && cart.items) ? cart.items.reduce(function (sum, it) { return sum + it.quantity; }, 0) : 0;

    // Ukážeme, keď má zákazník v košíku položky a chýba mu do plného setu (menej ako 5 vôní)
    if (totalItemsCount > 0 && count < 5) {
      var missing = 5 - count;
      var freeFrom = window.VELOUR.freeShippingFromCents || 5000;
      var rawTotal = cart ? cart.total_price : 0;
      var missingShipping = Math.max(0, freeFrom - rawTotal);

      if (incompleteTitle) {
        if (count === 0 || count === 1) {
          incompleteTitle.textContent = missingShipping > 0
            ? 'Vytvor si set 5 odstrekov — zľava 10 % aj doprava zadarmo'
            : 'Vytvor si set 5 odstrekov a ušetri 10 %';
        } else if (count === 4) {
          incompleteTitle.textContent = 'Chýba ti už len 1 vôňa k 10 % zľave na celý set!';
        } else {
          incompleteTitle.textContent = 'Už len ' + missing + ' vône k 10 % zľave na celý set!';
        }
      }
      if (incompleteSub) {
        if (count === 0) {
          incompleteSub.textContent = 'Poskladaj si set 5 ľubovoľných odstrekov (2, 5 alebo 10 ml) a získaj automatickú 10 % zľavu na celý set:';
        } else if (count === 1) {
          incompleteSub.textContent = missingShipping > 0
            ? 'V košíku máš 1 z 5 odstrekov. Pridaj ešte 4 vône (2, 5 alebo 10 ml) — získaš 10 % zľavu na všetky vône a doručenie na výdajné miesto zadarmo:'
            : 'V košíku máš 1 z 5 odstrekov. Pridaj ešte 4 vône (2, 5 alebo 10 ml) a zľava 10 % sa uplatní automaticky v košíku:';
        } else if (count === 4) {
          incompleteSub.textContent = 'V košíku máš 4 z 5 odstrekov. Pridaj 5. vôňu a automaticky získaš zľavu 10 % na všetky vône:';
        } else {
          incompleteSub.textContent = 'V košíku máš ' + count + ' z 5 odstrekov. Doplň ešte ' + missing + ' vône a automaticky získaš zľavu 10 % na všetky vône:';
        }
      }

      // Zistíme dominantnú veľkosť z odstrekov v košíku
      var sizeCounts = { '2ml': 0, '5ml': 0, '10ml': 0 };
      var cartVariantIds = [];
      (cart.items || []).forEach(function (it) {
        cartVariantIds.push(String(it.variant_id));
        var vt = (it.variant_title || '').trim().toLowerCase();
        if (sizeCounts[vt] != null) {
          sizeCounts[vt] += it.quantity;
        }
      });

      var targetSize = '2ml';
      if (sizeCounts['5ml'] > sizeCounts['2ml'] && sizeCounts['5ml'] >= sizeCounts['10ml']) {
        targetSize = '5ml';
      } else if (sizeCounts['10ml'] > sizeCounts['2ml'] && sizeCounts['10ml'] > sizeCounts['5ml']) {
        targetSize = '10ml';
      }
      currentIncompleteSize = targetSize;

      if (incompleteLink) {
        incompleteLink.href = '/collections/odstreky-parfumov?view=bundle&size=' + targetSize;
      }

      var visibleCount = 0;
      var sizePrefix = 'data-v' + targetSize.replace('ml', '') + '-';

      incompleteCards.forEach(function (c) {
        var vid = c.getAttribute(sizePrefix + 'id') || c.getAttribute('data-v2-id');
        var price = parseInt(c.getAttribute(sizePrefix + 'price') || c.getAttribute('data-v2-price') || '0', 10);
        var avail = (c.getAttribute(sizePrefix + 'avail') || c.getAttribute('data-v2-avail')) === '1';

        var isInCart = vid && cartVariantIds.indexOf(vid) !== -1;
        if (isInCart || !avail || price <= 0) {
          c.classList.add('is-in-cart');
          return;
        }

        c.classList.remove('is-in-cart');
        visibleCount++;

        c.setAttribute('data-variant-id', vid);
        var btn = c.querySelector('.cart-incomplete-add-btn');
        if (btn) {
          btn.setAttribute('data-variant-id', vid);
          btn.disabled = false;
          btn.textContent = '+ Pridať';
        }

        var sizeLabel = c.querySelector('.cart-incomplete-size-label');
        if (sizeLabel) sizeLabel.textContent = targetSize.replace('ml', ' ml');

        var disc = Math.round(price * 0.10);
        var finalP = price - disc;
        var wasEl = c.querySelector('.cart-incomplete-was');
        var nowEl = c.querySelector('.cart-incomplete-now');
        if (wasEl) wasEl.textContent = money(price);
        if (nowEl) nowEl.textContent = money(finalP);
      });

      incompleteBanner.hidden = (visibleCount === 0);
    } else {
      incompleteBanner.hidden = true;
    }

    // Pripomienka v súhrne nad tlačidlom Pokladňa
    var setReminder = document.getElementById('cartSetReminder');
    var setReminderTitle = document.getElementById('cartSetReminderTitle');
    if (setReminder) {
      if (count >= 1 && count <= 4) {
        setReminder.hidden = false;
        if (setReminderTitle) {
          var rem = 5 - count;
          var remW = rem === 1 ? 'Chýba ti už len 1 vôňa' : (rem >= 2 && rem <= 4 ? 'Chýbajú ti ešte ' + rem + ' vône' : 'Chýba ti ešte ' + rem + ' vôní');
          setReminderTitle.textContent = remW + ' k 10 % zľave na celý set';
        }
      } else {
        setReminder.hidden = true;
      }
    }
  }

  if (incompleteBanner) {
    incompleteBanner.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-incomplete-add-btn');
      if (!btn || btn.disabled) return;
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;

      btn.disabled = true;
      var origText = btn.textContent;
      btn.textContent = '…';

      window.VELOUR.cartAdd(parseInt(vid, 10), 1, { 'Sada': 'Set 5 odstrekov' }).then(function () {
        btn.textContent = '✓';
      }).catch(function (err) {
        btn.disabled = false;
        btn.textContent = origText;
        if (window.VELOUR && window.VELOUR.showToast) {
          window.VELOUR.showToast(err.message || 'Nepodarilo sa pridať vôňu');
        }
      });
    });
  }

  function scrollToIncompleteBanner() {
    if (!incompleteBanner || incompleteBanner.hidden) return;
    var nav = document.getElementById('nav');
    var navHeight = nav ? nav.getBoundingClientRect().height : 70;
    var rect = incompleteBanner.getBoundingClientRect();
    var availHeight = window.innerHeight - navHeight;
    var centerOffset = Math.max(30, (availHeight - rect.height) / 2);
    var targetY = window.scrollY + rect.top - navHeight - centerOffset;
    window.scrollTo({ top: Math.max(0, Math.round(targetY)), behavior: 'smooth' });
  }

  /* ---------- Free shipping upsell ---------- */
  var upsellBlock = document.getElementById('cartUpsell');
  var upsellMissingEl = document.getElementById('cartUpsellMissing');
  var upsellTitleEl = upsellBlock ? upsellBlock.querySelector('.cart-upsell-title') : null;
  var upsellSubEl = upsellBlock ? upsellBlock.querySelector('.cart-upsell-sub') : null;
  var upsellCards = upsellBlock ? Array.from(upsellBlock.querySelectorAll('.cart-upsell-card')) : [];

  function updateUpsell(effectiveTotal, cart) {
    if (!upsellBlock) return;
    var freeFrom = window.VELOUR.freeShippingFromCents || 5000;
    var missing = freeFrom - effectiveTotal;

    // Ak už má zákazník dopravu zadarmo (missing <= 0), alebo ak mu do 50 € chýba viac ako 24 €
    // (napr. má v košíku len 1 odstrek za ~13 €), tento box na dorovnanie poštovného nezobrazujeme —
    // pôsobilo by zvláštne ponúkať 1ml vzorku k 37 € chýbajúcej sume. Vtedy zákazník vidí vyššie banner na set 5 vôní.
    if (missing <= 0 || missing > 2400) {
      upsellBlock.hidden = true;
      return;
    }

    var activeSize = '1ml';
    if (missing <= 1200) {
      // Chýba do 12 €: 1 ml vzorky (5–7 €)
      activeSize = '1ml';
      if (upsellTitleEl) upsellTitleEl.innerHTML = 'Chýba ti už len <span id="cartUpsellMissing">' + money(missing) + '</span> k doprave zadarmo';
      if (upsellSubEl) upsellSubEl.textContent = 'Pridaj si 1 ml vzorku — namiesto poštovného získaš ďalší parfum:';
    } else {
      // Chýba 12 € až 24 €: 2 ml odstreky (10–16 €)
      activeSize = '2ml';
      if (upsellTitleEl) upsellTitleEl.innerHTML = 'Už len <span id="cartUpsellMissing">' + money(missing) + '</span> k doprave zadarmo';
      if (upsellSubEl) upsellSubEl.textContent = 'Pridaj si 2 ml odstrek a neplať za poštovné:';
    }

    var cartVariantIds = (cart.items || []).map(function (it) { return String(it.variant_id); });
    var visibleCount = 0;

    upsellCards.forEach(function (c) {
      var cardSize = c.getAttribute('data-size') || '1ml';
      var vid = c.getAttribute('data-variant-id');
      var isInCart = cartVariantIds.indexOf(vid) !== -1;

      if (cardSize === activeSize && !isInCart) {
        c.style.display = '';
        c.classList.remove('is-in-cart');
        visibleCount++;
      } else {
        c.style.display = 'none';
        c.classList.add('is-in-cart');
      }
    });

    upsellBlock.hidden = (visibleCount === 0);
  }

  if (upsellBlock) {
    upsellBlock.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-upsell-add-btn');
      if (!btn || btn.disabled) return;
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;

      btn.disabled = true;
      var origText = btn.textContent;
      btn.textContent = '…';

      window.VELOUR.cartAdd(parseInt(vid, 10), 1).then(function () {
        btn.textContent = '✓';
      }).catch(function (err) {
        btn.disabled = false;
        btn.textContent = origText;
        if (window.VELOUR && window.VELOUR.showToast) {
          window.VELOUR.showToast(err.message || 'Nepodarilo sa pridať vzorku');
        }
      });
    });
  }

  /* Delegovanie namiesto viazania na každé tlačidlo — obsah sa prekresľuje
     po každej zmene a inak by sa poslucháči museli zakaždým vešať nanovo. */
  items.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.cart-line-qty-btn');
    var removeBtn = e.target.closest('.cart-line-remove');
    if (!qtyBtn && !removeBtn) return;

    var key = (qtyBtn || removeBtn).getAttribute('data-key');
    var cart = window.VELOUR._lastCart;
    if (!cart) return;
    var item = cart.items.filter(function (it) { return it.key === key; })[0];
    if (!item) return;

    var next = removeBtn ? 0 : item.quantity + parseInt(qtyBtn.getAttribute('data-delta'), 10);
    if (next < 0) next = 0;

    window.VELOUR.changeLine(key, next);
  });

  /* Kliknutie na pripomienku nad pokladňou */
  var setReminderBtn = document.getElementById('cartSetReminderBtn');
  if (setReminderBtn) {
    setReminderBtn.addEventListener('click', function () {
      scrollToIncompleteBanner();
    });
  }

  /* Upozornenie pred pokladňou ak zákazníkovi chýba 1 vôňa do zľavy */
  var confirmModal = document.getElementById('cartSetConfirmModal');
  var confirmOverlay = document.getElementById('cartSetConfirmOverlay');
  var confirmPick = document.getElementById('cartSetConfirmPick');

  if (checkoutBtn && confirmModal) {
    checkoutBtn.addEventListener('click', function (e) {
      var cart = window.VELOUR._lastCart;
      var dInfo = cart && window.VELOUR.calculateCartDiscount ? window.VELOUR.calculateCartDiscount(cart) : null;
      var count = dInfo ? dInfo.qualifyingCount : 0;
      // Ak má zákazník 4 vône (chýba 1 do zľavy), dáme mu možnosť vybrať si ju a ušetriť
      if (count === 4) {
        e.preventDefault();
        confirmModal.hidden = false;
      }
    });
  }

  if (confirmPick) {
    confirmPick.addEventListener('click', function () {
      if (confirmModal) confirmModal.hidden = true;
      scrollToIncompleteBanner();
    });
  }

  if (confirmOverlay) {
    confirmOverlay.addEventListener('click', function () {
      if (confirmModal) confirmModal.hidden = true;
    });
  }

  /* Po výbere výdajného miesta je na mobile tlačidlo pokladne hlboko pod
     ohybom — mapa sa zavrie a zákazník zostane pozerať na kartu s adresou
     bez tušenia, že ho čaká ešte jeden krok. Prisunieme mu ho.

     Globe nevystavuje žiadnu udalosť, tak sledujeme, kedy sa v jeho časti
     objaví názov zvoleného miesta. Kým nie je nič vybraté, drží tam "-". */
  function scrollToCheckoutIfHidden() {
    var widget = deliveryBlock && deliveryBlock.querySelector('.globe-delivery-selector-container');
    if (!checkoutBtn || !widget) return;

    /* Hlavička je fixná, takže jej spodok je zároveň prvý riadok, ktorý
       zákazník reálne vidí. Čítame ho, nech to nie je zadrôtované číslo. */
    var nav = document.getElementById('nav');
    var horizont = nav ? nav.getBoundingClientRect().bottom : 0;
    var okraj = 12;

    var y = window.scrollY;
    var vrchWidgetu = widget.getBoundingClientRect().top + y;
    var spodokTlacidla = checkoutBtn.getBoundingClientRect().bottom + y;

    var potrebne = spodokTlacidla - vrchWidgetu;
    var kDispozicii = window.innerHeight - horizont - okraj * 2;

    /* Ak sa výber aj pokladňa zmestia naraz, zarovnáme vrch výberu tesne pod
       hlavičku — zákazník vidí, čo si zvolil, aj čím pokračuje. Keď sa to
       nezmestí (nižší telefón), tlačidlo má prednosť a prisadne na spodok. */
    var ciel = potrebne <= kDispozicii
      ? vrchWidgetu - horizont - okraj
      : spodokTlacidla - window.innerHeight + okraj;

    window.scrollTo({ top: Math.max(0, Math.round(ciel)), behavior: 'smooth' });
  }

  function watchPickupSelection() {
    if (!deliveryBlock) return;
    var last = '';
    var nacitane = Date.now();

    new MutationObserver(function () {
      var el = deliveryBlock.querySelector('[id^="globe-point-name"]');
      var name = el ? el.textContent.trim() : '';
      if (!name || name === '-' || name === last) return;

      var uzVybrateSkor = last === '' && Date.now() - nacitane < 4000;
      last = name;

      /* Globe si výber pamätá a po načítaní ho vypíše sám. To nie je voľba,
         ktorú zákazník práve spravil — keby sme aj vtedy rolovali, košík by
         mu pri otvorení odskočil dole. Prvé vykreslenie preto len zapíšeme. */
      if (uzVybrateSkor) return;

      /* Mapa sa zatvára s animáciou a dovtedy je rolovanie tela zamknuté —
         skočiť hneď by neurobilo nič. */
      setTimeout(scrollToCheckoutIfHidden, 400);
    }).observe(deliveryBlock, { childList: true, subtree: true, characterData: true });
  }

  window.VELOUR.onCartChange(render);
  watchPickupSelection();
})();
